import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { Colors } from "../../helpers/Consts";
import { IShoppingBagItem } from "../../types/ShoppingBag";

type Props = {
  singleItem: IShoppingBagItem;
};

/**
 * Para exibir os detalhes de um ITEM de pedido, por exemplo: quantidade, descrição, preço, sabores, observações, etc.
 *
 * @param {Object} props - As propriedades do componente.
 * @param {IShoppingBagItem} props.singleItem - O item para o qual deseja exibir os detalhes.
 *
 * @return {JSX.Element} O component que exibe os detalhes do item de pedido.
 */
function OrderItemDetails({ singleItem }: Props): JSX.Element {
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          border: "1px solid",
          borderRadius: "5px",
          height: "28px",
          width: "28px",
          borderColor: "#c3c3c3",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "11px",
            color: "#C4C4C4",
          }}
        >
          {singleItem.quantity}x
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            marginLeft: "10px",
            fontSize: "14px",
            color: Colors.baseTextColor,
            fontWeight: "700",
            lineHeight: "12px",
          }}
        >
          {singleItem.productInfo.name}
        </Typography>
        <Typography
          sx={{
            fontSize: "10px",
            color: "#383838",
            marginLeft: "13px",
          }}
        >
          {singleItem.quantity} x{" "}
          {singleItem.unit_price.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })}{" "}
          ={" "}
          {singleItem.total_price.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })}
        </Typography>
        {singleItem.hasComposition && (
          <>
            {singleItem.compositionGroups.map((item) => (
              item.compositionGroupItems.filter((compoItem) => compoItem.quantity > 0).map((item) => (
                <Typography

                  key={item.id}
                  sx={{
                    marginLeft: "26px",
                    fontSize: "10px",
                    color: "#383838",
                  }}>
                  {item.quantity}x - {item.name}
                </Typography>
              ))
            ))}
          </>
        )}
        {singleItem.observations && (
          <Typography
            sx={{
              marginLeft: "13px",
              fontSize: "10px",
              color: "#383838",
            }}
          >
            Obs: {singleItem.observations}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default OrderItemDetails;